import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Portfolio from "@/pages/Portfolio";
import CaseStudy from "@/pages/CaseStudy";
import Admin from "@/pages/Admin";
import { TransitionProvider } from "@/contexts/TransitionContext";
import useScrollbarGutterVar from "@/hooks/useScrollbarGutterVar";
import useVisualViewportCenter from "@/hooks/useVisualViewportCenter";
import useAnalytics from "@/hooks/useAnalytics";

// Small component sitting INSIDE <BrowserRouter> so useLocation is
// available. Fires a GA4 page_view event on every route change (details
// in /hooks/useAnalytics.js). Kept as its own component rather than
// inlined into <App /> because useAnalytics needs the Router context.
function AnalyticsListener() {
  useAnalytics();
  return null;
}

function App() {
  useScrollbarGutterVar();
  useVisualViewportCenter();
  return (
    <div className="App">
      <BrowserRouter>
        <AnalyticsListener />
        <TransitionProvider>
          <Routes>
            <Route path="/" element={<Portfolio />} />
            <Route path="/project/:slug" element={<CaseStudy />} />
            {/* Hidden admin route — NOT linked from anywhere on the public
                site. Discoverable only by directly typing /admin. Gated
                server-side by the ADMIN_TOKEN in /api/admin/login. */}
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </TransitionProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
